import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { ExpertisePage } from "@/pages/expertise";

export const Route = createFileRoute("/$lang/expertise")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "seo");
    return pageHead({
      lang,
      pathWithoutLang: "/expertise",
      title: t("expertise.title"),
      description: t("expertise.description"),
    });
  },
  component: ExpertisePage,
});
